const GET_ATM_ACCESS_TOKEN = 'GET_ATM_ACCESS_TOKEN';
const GET_ATM_ACCESS_TOKEN_SUCCESS = 'GET_ATM_ACCESS_TOKEN_SUCCESS';

const GET_ATMLOCATION_DATA_START = 'GET_ATMLOCATION_DATA_START';
const GET_ATMLOCATION_DATA_SUCCESS = 'GET_ATMLOCATION_DATA_SUCCESS';
const GET_ATMLOCATION_DATA_ERROR = 'GET_ATMLOCATION_DATA_ERROR';


const getAtmLocationData = () => {
	console.log("working 1")
	return {
		type: GET_ATMLOCATION_DATA_START,
	};
};

const getAtmAccessToken = () => {
	return {
		type: GET_ATM_ACCESS_TOKEN
	};
};

const getAtmAccessTokenSuccess = () => {
	return {
		type: GET_ATM_ACCESS_TOKEN_SUCCESS
	};
};

const getAtmLocationDataSuccess = (res) => {
	return {
		type: GET_ATMLOCATION_DATA_SUCCESS,
		res
	};
};

const getAtmLocationDataError = () => {
	return {
		type: GET_ATMLOCATION_DATA_ERROR,
	};
};

export default {
	types: {
		GET_ATM_ACCESS_TOKEN,
		GET_ATM_ACCESS_TOKEN_SUCCESS,

		GET_ATMLOCATION_DATA_START,
		GET_ATMLOCATION_DATA_SUCCESS,
		GET_ATMLOCATION_DATA_ERROR

	},
	creators: {
		getAtmAccessToken,
		getAtmAccessTokenSuccess,

		getAtmLocationData,
		getAtmLocationDataSuccess,
		getAtmLocationDataError
	},
};
